module.exports = __webpack_public_path__ + "static/village_slide_img04-d3ac8b177037568de79be91083528dd1.png";